import React from 'react'

import styled from 'styled-components/native'

import { BodyText, Size } from '../../atoms/bodyText/BodyText'
import { BodyTextSize, TextAlign } from '../../styles/typeStyles'
import { tID } from '../../utils/utils'

export interface InlineBannerProps {
  text: React.ReactNode | string
  backgroundColor: string
  textColor?: string
  testId?: string
  icon?: React.ReactNode
  trailingLink?: React.ReactElement
  marginBottom?: string
  marginTop?: string
  marginLeft?: string
  marginRight?: string
  textSize?: BodyTextSize
  borderRadius?: string
  padding?: string
  textAlign?: TextAlign
  title?: React.ReactNode | string
}
const Container = styled.View<{
  backgroundColor: string
  marginBottom?: string
  marginTop?: string
  marginLeft?: string
  marginRight?: string
  borderRadius?: string
  padding?: string
}>(({ backgroundColor, marginBottom, marginTop, marginLeft, marginRight, borderRadius, padding }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: marginBottom || '24px',
  marginTop,
  borderRadius: borderRadius || '16px',
  backgroundColor: backgroundColor,
  padding: padding || '12px',
  marginLeft,
  marginRight,
}))

const IconContainer = styled.View({
  alignSelf: 'flex-start',
  width: 24,
  height: 24,
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: 4,
})

const TextContainer = styled.View({
  flex: 1,
})

export const InlineBanner: React.FC<InlineBannerProps> = ({
  text,
  testId,
  backgroundColor,
  textColor,
  trailingLink,
  icon,
  marginBottom,
  marginTop,
  marginLeft,
  marginRight,
  textSize = Size.DEFAULT,
  borderRadius,
  padding,
  textAlign,
  title,
}) => (
  <Container
    backgroundColor={backgroundColor}
    marginBottom={marginBottom}
    marginTop={marginTop}
    marginLeft={marginLeft}
    marginRight={marginRight}
    testID={tID(testId)}
    borderRadius={borderRadius}
    padding={padding}
  >
    {icon && <IconContainer>{icon}</IconContainer>}
    <TextContainer>
      {title && (
        <BodyText size={textSize} text={title} color={textColor} bold style={text ? { marginBottom: 4 } : undefined} />
      )}
      <BodyText size={textSize} color={textColor} wrap text={text} textAlign={textAlign}>
        {trailingLink && <>&nbsp;{trailingLink}</>}
      </BodyText>
    </TextContainer>
  </Container>
)
